import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import VehicleAccessRightsOverview from './VehicleAccessRightsOverview';
import onPremiseVehicleAccessRightsService from '../services/onPremiseVehicleAccessRightsService';

class OnPremiseVehicleAccessRightsOverview extends PureComponent {
  render() {
    const {
      onPremiseVehicleAccessRightsFetch,
      dispatchOnPremiseVehicleAccessRightsGet,
      ...props
    } = this.props;
    return (
      <VehicleAccessRightsOverview
        fetch={onPremiseVehicleAccessRightsFetch}
        dispatchGet={dispatchOnPremiseVehicleAccessRightsGet}
        {...props}
      />
    );
  }
}

OnPremiseVehicleAccessRightsOverview.propTypes = {
  dispatchOnPremiseVehicleAccessRightsGet: PropTypes.func.isRequired,
  onPremiseVehicleAccessRightsFetch: PropTypes.object.isRequired,
};

export default compose(onPremiseVehicleAccessRightsService)(OnPremiseVehicleAccessRightsOverview);
